import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { envAwarePost, envAwareFormSubmit } from "../../util/util";
import classes from "./Profile.module.css";
import Button from 'react-bootstrap/Button';
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import InputGroup from "react-bootstrap/InputGroup";
import isEmail from 'validator/es/lib/isEmail'
import Cropper from "react-cropper";
import Spinner from "react-bootstrap/Spinner";
import { updateCustomApp } from "./profileSlice";
import CustomAppModal from "./CustomAppModal";
import useS3DirectUpload from '../../hooks/useS3DirectUpload'
import {setCurrentUser, updateProfileData} from '../users/usersSlice'
import {copyToClipboard} from '../../util/util'
import {Link} from 'react-router-dom'
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";
import useCurrentUser from '../../hooks/useCurrentUser'

function BasicInfo({ basicInfoData, editDBItem, errors, setErrors }) {
    const [profilePic, setProfilePic] = useState("")
    const [userName, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [passwordDuplicate, setPasswordDuplicate] = useState("");


    const [referralCode, setReferralCode] = useState("");
    const [accountDetails, setAccountDetails] = useState(null);
    const [passwordModal, setPasswordModal] = useState(false);

    const [logoImage, setLogoImage] = useState("")


    const [userIdModal, setUserIdModal] = useState(false);
    const [userIdTemp, setUserIdTemp] = useState("");

    const [logoImageButtonMessage, setLogoImageButtonMessage] = useState("");
    const [operationLogoImage, setOperationLogoImage] = useState("");

    const [profileImageButtonMessage, setProfileImageButtonMessage] = useState("");
    const [operationProfileImage, setOperationProfileImage] = useState("");
    const [showErrorMessage, setShowErrorMessage] = useState(false)

    const [isLoginSaving, setIsLoginSaving] = useState(false);
    const [isPasswordSaving, setIsPasswordSaving] = useState(false);

    const [showCustomAppModal, setShowCustomAppModal] = useState(false);
    const user = useSelector((state) => state.users.current_user);
    const dispatch = useDispatch();
    const statusDispatch = useApiStatusDispatch();

    const accountType = useSelector(state => state.users.current_user.account_type);
    const gymId = useSelector(state => state.users.current_user.gym_id);
    const customApp = (useSelector((state) => state.branding.width !== null));
    let customAppEdit;
    if (customApp && ((accountType==="trainer" && gymId === "0") || accountType==="gym")){
        // console.log(customApp, (accountType==="trainer" && gymId !== ""),accountType==="gym" )
        customAppEdit = true;
    } else {
        customAppEdit = false;
    }

    const pageTypeText = (
        accountType === 'gym'
        ? 'Gym'
        : 'Trainer'
    ) 
    
    const defaultLogoPlaceholder = "https://www.fitsw.com/upload/logos/defaultLogo.png";

    const {processUpload} = useS3DirectUpload()

    const isClient = accountType === "client";
    const isTrainer = accountType === "trainer";
    const isGym = accountType === "gym";

    useEffect(() => {
        if (basicInfoData) {
            let bioData = basicInfoData.user.bio_data;

            if (bioData) {
                setProfilePic(basicInfoData.user.profilePic)
                setAccountDetails(basicInfoData.usageData);

                setPhone(basicInfoData.user.user_phone)
                setUsername(basicInfoData.user.user_name);
                setEmail(basicInfoData.user.user_email);
                setUserId(basicInfoData.user.user_id);
                setReferralCode(basicInfoData.user.referralCode);

                if (!bioData.img) { //if there isnt a logo image then use default image.
                    setLogoImage(defaultLogoPlaceholder);
                    setLogoImageButtonMessage("Add Your Logo Image");
                    setOperationLogoImage("add");
                } else {
                    setLogoImage(bioData.img);
                    setLogoImageButtonMessage("Update Your Logo Image");
                    setOperationLogoImage("edit");
                }
                if (basicInfoData.user.profilePic == "") { //if there isnt a profile pic then use default image.
                    setProfilePic("https://cdn.fitsw.com/assets/img/defaultProfile.png");
                    setProfileImageButtonMessage("Add Profile Photo");
                    setOperationProfileImage("add");
                } else {
                    setProfilePic(basicInfoData.user.profilePic)
                    setProfileImageButtonMessage("Update Profile Photo");
                    setOperationProfileImage("edit");
                }
            }
        }
    }, [basicInfoData])

    const handlePasswordModalShow = () => setPasswordModal(true);

    const handleUserIdModalShow = () => {
        setUserIdModal(true);
        setUserIdTemp(userId);
    }

    function handlePasswordSave() {
        if (password.length < 6) {
            setErrors(prev => ({ ...prev, passwordSave: "Password must be at least 6 characters" }));
            return
        } else if (password !== passwordDuplicate) {
            setErrors(prev => ({ ...prev, passwordSave: "Passwords do not match" }));
            return
        }
        let payload = { value: password, field: "user_password", action:'updateProfileData' };
        setIsPasswordSaving(true)
        statusDispatch(updateProfileData(payload),"password","update")
            .then((res) => {
                setIsPasswordSaving(false)

                if (res.payload.success == "1") {
                    handlePasswordModalClose();
                } else {
                    console.log(res)
                }
            }).catch(err => console.log(err))
    }

    function handleUserIdSave() {
        if (!isEmail(userIdTemp)) {
            setErrors(prev => ({ ...prev, userId: "Invalid Email" }));
            return
        }
        let payload = {
            action:'updateProfileData',
            value: userIdTemp, 
            field: "user_id",
        }
        setIsLoginSaving(true)

        statusDispatch(updateProfileData(payload),"login email","update")
            .then((res) => {
                setIsLoginSaving(false)
                if (res.payload.success == "1") {
                    setUserIdModal(false);
                    setUserId(userIdTemp,setUserIdTemp(""));
                } else {
                    console.log(res)
                }


            }).catch(err => console.log(err))
    }


    const handlePasswordModalClose = () => {
        setPasswordModal(false);
        setPassword("");
        setPasswordDuplicate("");
    }

    const handleUserIdModalClose = () => {
        setUserIdTemp("");
        setUserIdModal(false);
    }

    let colSize = 5;

    const handleLogo = async (e, operationLogoImage) => { 
        if(e.target.files[0]){
            const s3Res = await processUpload(e.target.files[0])
            if(!s3Res.success){
                window.alert('There was an error saving your profile picture')
                return
            }
            envAwareFormSubmit({
                path: "/api/users/api",
                payload: {
                    action:'updateProfileData',
                    field: "logo_url",
                    value: s3Res.payload.url,
                }
            })
                .then(res => {
                    if (res.success == "1") {
                        setLogoImage(res.data.update.value)
                    } else {
                        console.log(res)
                    }
                }).catch(err => console.log(err))
        }//end if file
    }

   function handleRestoreDefaultLogo(){
       // will replace current url image with empty string
        envAwareFormSubmit({
            path: "/api/users/api",
            payload: {
                action:'updateProfileData',
                field: "logo_url",
                value: "",
            }
        }).then(res => {
            if (res.success == "1") {
                // set default image placeholder
                setLogoImage(defaultLogoPlaceholder)
            } else {
                console.log(res)
            }
        }).catch(err => console.log(err))
    }

    const [isUploadingPhoto, setIsUploadingPhoto] = useState(false)
    const [tempProfilePhoto, setTempProfilePhoto] = useState("")

    const [addImgURL, setAddImgURL] = useState("")

    const handleUploadProfileImage = (e) => {
        setIsUploadingPhoto(true)
        setTempProfilePhoto(e.target.files[0])
        setAddImgURL(URL.createObjectURL(e.target.files[0]))
    }

    const handleUploadProfileImageCancel = () => {
        setIsUploadingPhoto(false)
    }

    async function handleProfileImage() {
        const s3Res = await processUpload(tempProfilePhoto)
        if(!s3Res.success){
            window.alert('There was an error saving your profile picture')
            return
        }
        envAwareFormSubmit({
            path: "/api/users/api/",
            payload: {
                action:'updateProfileData',
                using_s3:1,
                profile_pic_url: s3Res.payload.url,
                field: "profilePic",
            }
        })
        .then(res => {
            if (res.success == "1") {
                let updatedUser = JSON.parse(JSON.stringify(user))
                updatedUser.profilePic = s3Res.payload.url
                dispatch(setCurrentUser(updatedUser)) 

                //setProfileImage(res.data.imageString)
                setProfilePic(s3Res.payload.url);
                setShowErrorMessage(false)
            } else {
                console.log(res)
                setShowErrorMessage(true)
            }
            setIsUploadingPhoto(false)

        }).catch(err => console.log(err))
    }



    const passwordView = useRef(null);
    const passwordViewDuplicate = useRef(null);


    function handlePasswordView(password) {
        if (password == "original") {
            if (passwordView.current.type === "password") {
                passwordView.current.setAttribute("type", "text");
            } else {
                passwordView.current.setAttribute("type", "password");
            }

        }

        if (password == "duplicate") {
            if (passwordViewDuplicate.current.type === "password") {
                passwordViewDuplicate.current.setAttribute("type", "text");
            } else {
                passwordViewDuplicate.current.setAttribute("type", "password");
            }
        }

    }
    function getColorClass(max, used) {
        return used >= Math.floor(max * .85) ? 'text-danger limitWarning' : 'text-primary';
    }


    return (
        <>
            <div style={{ backgroundColor: "#f7f8f9", padding: "50px", boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)", borderRadius: "5px" }}>
                {/* Profile pic */}
                <div className="text-center">
                    {isUploadingPhoto ? 
                    <img className="mb-2 rounded-circle profilePic" src={addImgURL} alt="profile picture" width="150" height="150" id="profilePicFile" data-no-retina />
                    
                    : 
                    <img className="mb-2 rounded-circle profilePic" src={profilePic} alt="profile picture" width="150" height="150" id="profilePicFile" data-no-retina />
                    
                    }
                    <br />

                    {isUploadingPhoto ? 
                        <Row style={{justifyContent:"center"}}>
                         <Button variant="danger" size="sm" onClick={handleUploadProfileImageCancel} style={{marginRight:"15px"}}>Cancel</Button>
                         <Button variant="success" size="sm" onClick={handleProfileImage} >Save</Button>
                        </Row>
                    :
                    <>
                        <label htmlFor="newProfilePhoto" className="btn btn-secondary btn-sm fileinput-button">
                        {/*The file input field used as target for the file upload widget --></Button>*/}
                        {profileImageButtonMessage}
                        </label>

                        <input style={{ display: "none" }} type="file" id="newProfilePhoto" name="profilePicFile"
                            onChange={(e) => handleUploadProfileImage(e, operationProfileImage)}
                            // onChange={(e) => handleProfileImage(e, operationProfileImage)}
                            // setAddModalImg(e.target.files[0]);
                            // addImgRef.current = URL.createObjectURL(e.target.files[0]);
                        />
                    </>
                    }


                    {showErrorMessage ? <p style={{ color: 'red' }}>Invalid filetype. Try using jpg, jpeg, or png. </p> : null}
                </div>

                <br />
                <br />

                {/* Display Name */}

                <Form.Group className="mb-5" controlId="user_name">
                    <Form.Label className="col-form-label"> <u> Display Name </u> </Form.Label>
                    <Form.Control name="user_name" className="form-control-alternative" value={userName} required placeholder="Display Name Shown to Clients" type="text"
                        onChange={(e) => {
                            setUsername(e.target.value);
                            editDBItem(e);
                        }} />
                    <div className="text-danger">{errors && errors.displayName} </div>
                </Form.Group>


                {/* General Info */}

                <div>
                    {/* Login Email Address */}
                    <Form.Group className="mb-5" controlId="newusername">
                        <Form.Label className="col-form-label" ><u>Login Email</u></Form.Label>
                        <Form.Text className="form-control-plaintext">
                            <strong> {userId} </strong>
                        </Form.Text>
                        <Form.Text className="form-control-plaintext" onClick={(e) => { handleUserIdModalShow(e); }}>
                            <Button variant="link"> Change Login Email </Button>
                        </Form.Text>
                    </Form.Group>

                    {/* Account Details */}
                </div>
                {/* {console.log('accountDetails: ', accountDetails)} */}
                <div className={`${classes.accountDetails} mb-5 mt-2`}>
                    {((isTrainer && gymId === "0") || isGym) && accountDetails &&
                        <>
                            <label><u>Account Details</u></label>
                            <div
                                style={{ textTransform: "capitalize", fontSize: "1.2rem" }}
                                className="currentPlanClients mb-3">
                                {user.account_type} {accountDetails?.clients?.max} Plan
                            </div>


                            {Object.entries(accountDetails).map(([key, item]) => {
                                return (
                                    <div key={key} className="mb-2">
                                        {key === "pics" ? 
                                            <>
                                                <span className={getColorClass(item.max, item.used)}> {item.used} </span> of <span className={getColorClass(item.max, item.used)}> {item.max} </span> progress pictures used
                                            </>
                                        :
                                        <>
                                            {(key === "trainers" && user.account_type === "gym") &&
                                            <div  >
                                                <span className={getColorClass(item.max, item.used)}> {item.used} </span> of <span className={getColorClass(item.max, item.used)}> {item.max} </span> trainer profiles used
                                            </div>
                                            }
                                            {key !== "trainers" &&
                                                <div >
                                                    <span className={getColorClass(item.max, item.used)}> {item.used} </span> of <span className={getColorClass(item.max, item.used)}> {item.max} </span> {key}  used
                                                </div>
                                            }
                                        </>
                                        }
                                    </div>
                                )
                            }
                            )}
                            <div>
                                <a href="https://www.fitsw.com/upgrade/" className="btn btn-sm m-2 px-4 btn-primary">Upgrade Plan</a>
                            </div>
                        </>}

                    {/*	 Contact Email Address */}
                    <Form.Group className="my-5" controlId="user_email">
                        <Form.Label className="col-form-label"><u> Contact Email</u></Form.Label>
                        <Form.Control name="user_email" type="email" className="form-control-alternative" value={email} required="" onChange={
                            (e) => {
                                setEmail(e.target.value);
                                editDBItem(e);
                            }} />
                        <Form.Text>
                            <small>This just changes the email you receive notifications at. It does <strong><u>not</u></strong> change your login email.</small>
                        </Form.Text>
                        <div className="text-danger">{errors && errors.contactEmail} </div>

                    </Form.Group>

                    {/*	 Phone Number */}
                    <Form.Group className="mb-5" controlId="phone" >
                        <Form.Label className="col-form-label"> <u> Phone </u></Form.Label>
                        <Form.Control name="phone" className="form-control-alternative" type="text" placeholder="Optional" value={phone} onChange={(e) => {
                            setPhone(e.target.value)
                            editDBItem(e)
                        }} />
                    </Form.Group>

                    {/*	 Password */}
                    <Form.Group className="mb-5" controlId="changePasswordItem" >
                        <Form.Label className="col-form-label"> <u> Password </u></Form.Label>
                        <Form.Text className="form-control-plaintext" onClick={handlePasswordModalShow}>
                            <Button variant="link"> Change Password </Button>
                        </Form.Text>
                    </Form.Group>

                    {/*	 Account Type */}

                    <Form.Group className="mb-5" controlId="acctype" >
                        <Form.Label className="col-form-label"><u> Account Type </u></Form.Label>
                        <Form.Text className="form-control-plaintext">
                            {(isTrainer && gymId !== "0") ?
                                <div style={{ textTransform: "capitalize", fontSize: "1.2rem" }}>
                                    Gym Trainer Plan
                                </div> :
                                accountDetails &&
                                <p id="acctype" style={{ textTransform: "capitalize" }} >
                                    {user.account_type} {accountDetails?.clients?.max} plan with {user.account_type} ID Code <u><strong>
                                        {user.user_id_number} </strong></u>
                                </p>
                            }
                        </Form.Text>
                    </Form.Group>

                    {/* if referral code */}
                    {((isTrainer && gymId === "0") || (isGym)) &&
                        <div className="col-form-label mb-3">
                            <strong><u><Link to="/referrals">Go to referrals page</Link></u></strong>
                        </div>
                    }
                </div>

                <div>
                    You can now customize your {pageTypeText} Page & Custom Apps in the <Link to="/customization-dashboard">Customization Dashboard</Link>
                </div>
            </div>


            <Modal aria-hidden="false" tabIndex="-1" show={passwordModal} onHide={handlePasswordModalClose}>
                <div className="modal-content">
                    <Modal.Header className="modal-header">
                        <Modal.Title className="modal-title"> <h4> Change Password </h4></Modal.Title>
                        <button type="button" className="close" onClick={() => setPasswordModal(false)} aria-hidden="true">&times;</button>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <InputGroup className="mb-3 input-group-alternative" controlId="changePasswordItem_modal">
                            <InputGroup.Prepend>
                                <InputGroup.Text><i className="fas fa-unlock-alt"></i></InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control ref={passwordView} aria-label="password" name="user_password" className="form-control password" placeholder="New Password" value={password} type="password" onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" required />
                            <InputGroup.Append>
                                <InputGroup.Text style={{ cursor: "pointer" }} onClick={() => handlePasswordView("original")}><i className="fa fa-eye passwordShowHide" title="Show/Hide Password"></i></InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                        <InputGroup className="mb-3 input-group-alternative" controlId="changePasswordItem_modal">
                            <InputGroup.Prepend>
                                <InputGroup.Text><i className="fas fa-unlock-alt"></i></InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control ref={passwordViewDuplicate} aria-label="password" name="user_password" className="form-control password" placeholder="Confirm New Password" value={passwordDuplicate} type="password" onChange={(e) => setPasswordDuplicate(e.target.value)} autoComplete="new-password" required />
                            <InputGroup.Append>
                                <InputGroup.Text style={{ cursor: "pointer" }} onClick={() => handlePasswordView("duplicate")}><i className="fa fa-eye passwordShowHide" title="Show/Hide Password"></i></InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                        <div className="text-danger">{errors && errors.passwordSave} </div>

                    </Modal.Body>
                    <Modal.Footer  >
                        <Button disabled={isPasswordSaving} className="btn-block" variant="primary" onClick={handlePasswordSave}>
                            {isPasswordSaving ? <Spinner size="sm" animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner> : "Update Password"}
                        </Button>
                    </Modal.Footer>
                </div>
            </Modal>


            <Modal aria-hidden="false" tabIndex="-1" show={userIdModal} onHide={handleUserIdModalClose}>
                <div className="modal-content">
                    <Modal.Header >
                        <Modal.Title > <h4> Change Login Email </h4></Modal.Title>
                        <button type="button" class="close" onClick={() => setUserIdModal(false)} aria-hidden="true">&times;</button>
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <Form>
                            <Form.Group className="form-group" controlId="newusername_modal">
                                <Form.Label className="sr-only"> Login Email </Form.Label>
                                <Form.Control name="user_login" className="form-control email" placeholder="New Login Email" value={userIdTemp} autoComplete="email" required type="email" onChange={(e) => setUserIdTemp(e.target.value)} />
                                <div className="text-danger">{errors && errors.userId} </div>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button disabled={isLoginSaving} className=" btn-block" variant="primary" onClick={handleUserIdSave}>
                        {isLoginSaving ? <Spinner size="sm" animation="border" role="status">
                                <span className="sr-only">Loading...</span>
                            </Spinner> : "Update Login Email"}
                        </Button>
                    </Modal.Footer>
                </div>
            </Modal>
        </>
    )

}

export default BasicInfo;